import React, { ForwardedRef, forwardRef, HTMLAttributes, PropsWithChildren } from 'react';
import styles from './WideBanner.module.scss';
import cls from 'classnames';

export const WideBanner = forwardRef(
  ({ children, className, ...rest }: PropsWithChildren<WideBannerProps>, ref) => {
    return (
      <article
        className={cls(styles.wideBanner, className)}
        ref={ref as ForwardedRef<any>}
        {...rest}
      >
        {children}
      </article>
    );
  },
);

WideBanner.displayName = 'WideBanner';

export type WideBannerProps = HTMLAttributes<HTMLBaseElement> & {};
